import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit';
import { toast, Flip } from 'react-toastify';

import { appSlice, configSlice } from '../store';
import { api } from '../api';

const ENDPOINTS_WITH_SUCCESSFULL_TOAST = ['updateCampaign', 'updateCoupons'];
const ENDPOINTS_WITHOUT_ERROR_TOAST = [
  'getUser',
  'signIn',
  'signUp',
  'requestResetPassword',
  'setNewPassword',
  'getGameResultFromSite',
  'activateAmoCRM',
  'sendTestLead',
  'getAmoCRMPipelines',
  'getAmoCRMPipelineStatuses',
  'getGetResponseLists',
];

const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
  const getErrorMessage = () => {
    if (action.payload?.data?.error) {
      return `${action.payload.data.error}: ${action.payload.data.message || ''}`;
    }

    return 'Internal Server Error';
  };

  if (
    action.error?.message &&
    action.payload?.data?.statusCode &&
    !ENDPOINTS_WITHOUT_ERROR_TOAST.includes(action.meta?.arg?.endpointName)
  ) {
    toast.error(getErrorMessage(), { toastId: 'error' });
  }

  if (
    action.type === 'api/executeMutation/fulfilled' &&
    ENDPOINTS_WITH_SUCCESSFULL_TOAST.includes(action.meta?.arg?.endpointName)
  ) {
    toast.success('Saved successfully', {
      autoClose: 1000,
      hideProgressBar: true,
      pauseOnHover: false,
      toastId: 'saved',
      position: 'bottom-right',
      closeButton: false,
      className: 'toast-saved-success',
      transition: Flip,
    });
  }

  return next(action);
};

export const store = configureStore({
  reducer: {
    app: appSlice.reducer,
    config: configSlice.reducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([api.middleware, rtkQueryErrorLogger]),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
